// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/fonts/Redzone-BoldCond.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/fonts/Redzone-BoldSemiCond.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/fonts/Redzone-BoldSemiExtd.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./assets/fonts/Redzone-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./assets/fonts/Redzone-MediumExtd.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./assets/fonts/Redzone-MediumSemiCond.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Figtree:wght@100;200;300;400;500;600;700;800;900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* styles.css */
/* Import Google Font */

/* Define custom fonts */
@font-face {
    font-family: 'Redzone Bold Condensed';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
    font-weight: bold;
    font-style: normal;
}

@font-face {
    font-family: 'Redzone Bold SemiCondensed';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype');
    font-weight: bold;
    font-style: normal;
}

@font-face {
    font-family: 'Redzone Bold SemiExtended';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype');
    font-weight: bold;
    font-style: normal;
}

@font-face {
    font-family: 'Redzone Medium';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('truetype');
    font-weight: normal;
    font-style: normal;
}

@font-face {
    font-family: 'Redzone Medium Extended';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('truetype');
    font-weight: normal;
    font-style: normal;
}

@font-face {
    font-family: 'Redzone Medium SemiCondensed';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('truetype');
    font-weight: normal;
    font-style: normal;
}


/* ---------------------------------- */


/* Left Navigation Styles */
#left-nav {
    width: 6%; /* Adjust the width as needed */
    background-color: black;
    color: var(--text-color);
    position: fixed;
    top: 0;
    left: 0;
    height: 100%; /* Full height of the viewport */
    /* padding: 0em 10px 0 10px; */
    padding-right: 3px;
    padding-left: 3px;
    box-sizing: border-box; /* Ensure padding is included in the width */
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
}

#logo {
    width: 100%;
    /* padding: 1em 0; */
    text-align: center;
    box-sizing: border-box;
}

#logo img {
    max-width: 80%;
    height: auto;
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA,eAAe;AACf,uBAAuB;;AAGvB,wBAAwB;AACxB;IACI,qCAAqC;IACrC,+DAAkE;IAClE,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,yCAAyC;IACzC,+DAAsE;IACtE,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,wCAAwC;IACxC,+DAAsE;IACtE,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;IAC7B,+DAAgE;IAChE,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,sCAAsC;IACtC,+DAAoE;IACpE,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,2CAA2C;IAC3C,+DAAwE;IACxE,mBAAmB;IACnB,kBAAkB;AACtB;;;AAGA,uCAAuC;;;AAGvC,2BAA2B;AAC3B;IACI,SAAS,EAAE,+BAA+B;IAC1C,uBAAuB;IACvB,wBAAwB;IACxB,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY,EAAE,gCAAgC;IAC9C,8BAA8B;IAC9B,kBAAkB;IAClB,iBAAiB;IACjB,sBAAsB,EAAE,4CAA4C;IACpE,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,oBAAoB;IACpB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,YAAY;AAChB","sourcesContent":["/* styles.css */\n/* Import Google Font */\n@import url('https://fonts.googleapis.com/css2?family=Figtree:wght@100;200;300;400;500;600;700;800;900&display=swap');\n\n/* Define custom fonts */\n@font-face {\n    font-family: 'Redzone Bold Condensed';\n    src: url('./assets/fonts/Redzone-BoldCond.ttf') format('truetype');\n    font-weight: bold;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: 'Redzone Bold SemiCondensed';\n    src: url('./assets/fonts/Redzone-BoldSemiCond.ttf') format('truetype');\n    font-weight: bold;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: 'Redzone Bold SemiExtended';\n    src: url('./assets/fonts/Redzone-BoldSemiExtd.ttf') format('truetype');\n    font-weight: bold;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: 'Redzone Medium';\n    src: url('./assets/fonts/Redzone-Medium.ttf') format('truetype');\n    font-weight: normal;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: 'Redzone Medium Extended';\n    src: url('./assets/fonts/Redzone-MediumExtd.ttf') format('truetype');\n    font-weight: normal;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: 'Redzone Medium SemiCondensed';\n    src: url('./assets/fonts/Redzone-MediumSemiCond.ttf') format('truetype');\n    font-weight: normal;\n    font-style: normal;\n}\n\n\n/* ---------------------------------- */\n\n\n/* Left Navigation Styles */\n#left-nav {\n    width: 6%; /* Adjust the width as needed */\n    background-color: black;\n    color: var(--text-color);\n    position: fixed;\n    top: 0;\n    left: 0;\n    height: 100%; /* Full height of the viewport */\n    /* padding: 0em 10px 0 10px; */\n    padding-right: 3px;\n    padding-left: 3px;\n    box-sizing: border-box; /* Ensure padding is included in the width */\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: center;\n}\n\n#logo {\n    width: 100%;\n    /* padding: 1em 0; */\n    text-align: center;\n    box-sizing: border-box;\n}\n\n#logo img {\n    max-width: 80%;\n    height: auto;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
